let Lineups = {
    GET_LINEUPS_REQUEST: 'GET_LINEUPS_REQUEST',
    GET_LINEUPS_SUCCESS: 'GET_LINEUPS_SUCCESS',
    UNSET_LINEUPS: 'UNSET_LINEUPS',
    UNSET_RUN: 'UNSET_RUN',
    SET_LINEUPS_USED_PLAYERS: 'SET_LINEUPS_USED_PLAYERS',
    SET_LINEUP_PLAYER_MAP: 'SET_LINEUP_PLAYER_MAP',
    SET_LINEUP_TEAM_COMBINATIONS_MAP: 'SET_LINEUP_TEAM_COMBINATIONS_MAP',
    SET_LINEUP_CORRELATION_STACK_COMBINATIONS_MAP: 'SET_LINEUP_CORRELATION_STACK_COMBINATIONS_MAP',
    SET_LINEUP_KEY_PLAYER_STACK_COMBINATIONS_MAP: 'SET_LINEUP_KEY_PLAYER_STACK_COMBINATIONS_MAP',

    SET_RAW_LINEUP: 'SET_RAW_LINEUP',
    UNSET_RAW_LINEUPS: 'UNSET_RAW_LINEUPS',

    SET_PREVIOUS_LINEUPS: 'SET_PREVIOUS_LINEUPS',
    USE_SAVING_PREVIOUS_LINEUP: 'USE_SAVING_PREVIOUS_LINEUP',

    SAVE_RUN_SETTINGS: 'SAVE_RUN_SETTINGS',

    SET_RANDOM_POINTS: 'SET_RANDOM_POINTS',
    UNSET_RANDOM_POINTS: 'UNSET_RANDOM_POINTS',

    SET_PROJECTED_BY: 'SET_PROJECTED_BY',
    SET_UNIQUE_PLAYERS: 'SET_UNIQUE_PLAYERS',
    SET_OPPOSING_PLAYERS: 'SET_OPPOSING_PLAYERS',
    SET_LINEUPS_COUNT: 'SET_LINEUPS_COUNT',
    SET_SALARY_CAP: 'SET_SALARY_CAP',
    SET_SALARY_CAP_RANGE: 'SET_SALARY_CAP_RANGE',
    SET_RANGE_OF_OUTCOMES: 'SET_RANGE_OF_OUTCOMES',
    SET_RANGE_OF_OUTCOMES_BY_POSITIONS: 'SET_RANGE_OF_OUTCOMES_BY_POSITIONS',
    RESET_LINEUP_PLAYER_FILTER: 'RESET_LINEUP_PLAYER_FILTER',
    SET_DEFAULT_VALUES_FOR_LINEUPS_FILTERS: 'SET_DEFAULT_VALUES_FOR_LINEUPS_FILTERS',
    RESET_LINEUPS_FILTERS: 'RESET_LINEUPS_FILTERS',

    SET_ALLOW_OPPOSING_TEAMS_IN_LINEUP: 'SET_ALLOW_OPPOSING_TEAMS_IN_LINEUP',
    SET_ALLOW_ONLY_ONE_K_POSITION_PER_LINEUP: 'SET_ALLOW_ONLY_ONE_K_POSITION_PER_LINEUP',
    SET_ALLOW_ONLY_ONE_DST_POSITION_PER_LINEUP: 'SET_ALLOW_ONLY_ONE_DST_POSITION_PER_LINEUP',
    SET_USE_OPPOSING_GOALIE: 'SET_USE_OPPOSING_GOALIE',
    SET_AVOID_FEW_PASS_RECEIVERS: 'SET_AVOID_FEW_PASS_RECEIVERS',
    SET_PRIORITIZE_COMPLETING_LINEUPS_ABOVE_EXP_MAX: 'SET_PRIORITIZE_COMPLETING_LINEUPS_ABOVE_EXP_MAX',
    SET_HITTERS_ORDER: 'SET_HITTERS_ORDER',
    SET_LINE_GROUPS: 'SET_LINE_GROUPS',
    F1_STACK_CAPTAIN_TO_CONSTRUCTOR: 'F1_STACK_CAPTAIN_TO_CONSTRUCTOR',
    STACK_QUARTERBACK_WITH_PASS_CATCHERS: 'STACK_QUARTERBACK_WITH_PASS_CATCHERS',
    SET_LIMIT_ONE_PITCHER_PER_GAME: 'SET_LIMIT_ONE_PITCHER_PER_GAME',

    SET_FLEX_MAX_EXPOSURE_POSITION: 'SET_FLEX_MAX_EXPOSURE_POSITION',
    RESET_FLEX_MAX_EXPOSURE_POSITION: 'RESET_FLEX_MAX_EXPOSURE_POSITION',

    SET_SUPERFLEX_POSITION: 'SET_SUPERFLEX_POSITION',
    SET_SUPERFLEX_MAX_EXPOSURE_POSITION: 'SET_SUPERFLEX_MAX_EXPOSURE_POSITION',
    RESET_SUPERFLEX_MAX_EXPOSURE_POSITION: 'RESET_SUPERFLEX_MAX_EXPOSURE_POSITION',

    SET_STATUS_OF_LINEUPS_IS_FILLED: 'SET_STATUS_OF_LINEUPS_IS_FILLED',

    SET_EXPOSURE_MODE: 'SET_EXPOSURE_MODE',
    EXPOSURE_MODE_OPTIMAL: 'EXPOSURE_MODE_OPTIMAL',
    EXPOSURE_MODE_BALANCED: 'EXPOSURE_MODE_BALANCED',
    EXPOSURE_MODE_TOURNAMENT: 'EXPOSURE_MODE_TOURNAMENT',
    EXPOSURE_MODE_DISTRIBUTED: 'EXPOSURE_MODE_DISTRIBUTED',

    SORT_BY_DEFAULT_VALUE: 'totalLineupPoints',
    SORT_BY_LINEUP_POINTS: 'totalLineupPoints',
    SORT_BY_ADMIN_POINTS: 'totalAdminPoints',
    SORT_BY_FINAL_POINTS: 'totalFinalPoints',
    SORT_BY_SALARY: 'totalSalary',
    SORT_BY_TOTAL_POWNS: 'totalProjOwn',

    NFL_FANTASY_DRAFT_LINEUP_FLEX_POSITIONS_QUANTITY: 2,

    FILTER_DASHBOARD_ITEMS: {
        totalLineupPoints: 'Fantasy Points',
        totalAdminPoints: 'Projection',
    },
    EXTRA_FILTER_DASHBOARD_ITEMS: {
        classic: {
            nfl: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            cfb: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            golf: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            mlb: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            mma: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            nascar: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            nba: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            nhl: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            lol: {
                totalSalary: 'Salary',
            },
            tennis: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
        },
        tiers: {
            nfl: {
                totalProjOwn: 'Total pOwns',
            },
            golf: {
                totalProjOwn: 'Total pOwns',
            },
        },
        showdown: {
            nfl: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            mma: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            nba: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            mlb: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            cfb: {
                totalSalary: 'Salary',
            },
        },
        'single-game': {
            nfl: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            nba: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            mlb: {
                totalSalary: 'Salary',
                totalProjOwn: 'Total pOwns',
            },
            cfb: {
                totalSalary: 'Salary',
            },
        },
    },

    MAX_GENERATED_LINEUPS_QUANTITY: 600,

    POINTS_DECIMAL_PRECISION: 3,
};

export default Lineups;
